import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, type FC, type ReactNode } from "react";
import type { RootState } from "../../store/store";
import { resolvePostLoginRedirect, syncPendingAuthRedirectFromSearch } from "@utils/authRedirect";

interface GuestGuardProps {
	children: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
	const { isAuthenticated } = useSelector((state: RootState) => state.user);
	const location = useLocation();

	useEffect(() => {
		syncPendingAuthRedirectFromSearch(new URLSearchParams(location.search));
	}, [location.search]);

	if (isAuthenticated) {
		const to = resolvePostLoginRedirect({
			attemptedLocation: null,
			searchParams: new URLSearchParams(location.search),
		});
		return <Navigate to={to} replace />;
	}
	return <>{children}</>;
};

export default GuestGuard; 